import { ShieldCheck, ShieldAlert } from "lucide-react";
import { cn } from "@/lib/utils";

export function VerifiedBadge({
	verified,
	className,
}: {
	verified: boolean;
	className?: string;
}) {
	if (verified) {
		return (
			<span className={cn("certified-badge", className)}>
				<ShieldCheck className="size-3" aria-hidden />
				Verified
			</span>
		);
	}
	return (
		<span
			className={cn(
				"inline-flex items-center gap-1 rounded-full border border-warning/40 bg-warning/10 px-2 py-0.5 font-mono text-[10px] font-semibold uppercase tracking-wider text-warning",
				className,
			)}
		>
			<ShieldAlert className="size-3" aria-hidden />
			Unverified
		</span>
	);
}
